import Vue from 'vue'
import VtCollapsableCard from '@/components/common/VtCollapsableCard.vue'
Vue.component('VtCollapsableCard', VtCollapsableCard)
